import SeenThingsCloseButton from '@Components/Modals/SeenThings/Components/SeenThingsCloseButton';
import { useSeenThingsPresenter } from '@Components/Modals/SeenThings/SeenThingsPresenter';
import { observer } from 'mobx-react-lite';
import React from 'react';

import HamburgerButton from './HamburgerButton/HamburgerButton';
import { useHamburgerButtonPresenter } from './HamburgerButton/HamburgerButton.presenter';
import SeenThingsPanel from './SeenThingsPanel';
import SideDrawerRightPanel from './SideDrawerRightPanel';

const SideDrawerRight = () => {
  const { isOpen, showHamburger } = useHamburgerButtonPresenter();
  const { visible: seenThingsVisible, showEyeIcon } = useSeenThingsPresenter();

  return (
    <>
      {isOpen.value && <SideDrawerRightPanel />}
      {showHamburger && <HamburgerButton />}
      {seenThingsVisible.value && <SeenThingsPanel />}
      {showEyeIcon && <SeenThingsCloseButton />}
    </>
  );
};

export default observer(SideDrawerRight);
